import { useEffect, useState } from "react";
import { IDMEPopupStyle } from "../../Theme";
import Success from "./Success";
import Failure from "./Failure";
import SelectAuthentication from "./SelectAuthentication";
import MFASetups from "./MFASetups";
import CompleteMFAEvent from "./CompleteMFAEvent";
import CheckMFAEventStatus from "./CheckMFAEventStatus";
import { Grid } from "@mui/material";
import DigitalRxLogo from "../../images/icons/DRxLogo.svg";
import IDMELogo from "../../images/icons/IDme.svg";
import { CircularProgress } from "@mui/material";
import { getUserUuid } from "../../Apis/Idme2FA";
import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSteps } from "../../Redux/Slice/IdmeSlice";
import MFASetupPreference from "./MFASetupPreference";
import InvalidCode from "./InvalidCode";
import SessionTimeOut from "./SessionTimeOut";
import ServiceUnavailable from "./ServiceUnavailable";

export default function IDME({
  URL,
  handleHidePopupClick,
  setVerifiedByIdmeUuid,
}: any) {
  const IdmePreferenceData = useSelector((state: any) => {
    return { ...state.IdmeSlice };
  }); //redux data
  const dispatch = useDispatch();
  const [userUuidData, setUserUuidData] = useState<any>(null);
  const [uuidError, setuuidError] = useState<string | null>(null);
  const [userUuidLoading, setUserUuidLoading] = useState<boolean>(true);
  const [isBack, setIsBack] = useState<boolean>(false);
  const [mfaSetupsData, setMfaSetupsData] = useState<any>([]);
  const getUserUuidData = async (isInIframe: Boolean) => {
    try {
      const params: any = new URLSearchParams();
      params.append("userId", localStorage.getItem("LoginUserID"));
      const result = await getUserUuid(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (
          result?.data?.response[0]?.savedPreferenceForRoute === 0 &&
          isInIframe === false
        ) {
          localStorage.setItem("savedPreferenceForRoute", "0");
          localStorage.removeItem("userIdmeUuid");
          window.open(`${URL}`, "_self");
          setuuidError(null);
        } else if (
          result?.data?.response[0]?.savedPreferenceForRoute === 1 ||
          isInIframe === true
        ) {
          dispatch(setSteps("two"));
          setUserUuidLoading(false);
          setuuidError(null);
          localStorage.setItem("userIdmeUuid", result?.data?.response[0]?.uuid);
        } else {
          dispatch(setSteps("one"));
          setUserUuidLoading(false);
          setuuidError(null);
          localStorage.setItem("userIdmeUuid", result?.data?.response[0]?.uuid);
        }
        setUserUuidData(result?.data?.response[0]);
      } else if (result?.data?.digitalRxStatusCode === 503) {
        setUserUuidLoading(false);
        dispatch(setSteps(null));
      } else {
        window.open(`${URL}`, "_self");
        setUserUuidData([]);
      }
    } catch (error) {
      setUserUuidData([]);
      setUserUuidLoading(false);
      setuuidError("Something went wrong, Try Again After Sometime!");
    }
  };

  useEffect(() => {
    getUserUuidData(window.self !== window.top);
  }, []);

  if (userUuidLoading) {
    return (
      <Grid
        container
        height={384}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Grid item>
          <CircularProgress color="primary" />
        </Grid>
      </Grid>
    );
  }

  if (uuidError) {
    return (
      <>
        <IDMEPopupStyle>
          <Grid
            container
            height={384}
            className="logos"
            flexDirection={"column"}
          >
            <Grid item>
              <Box className="logos">
                <img src={IDMELogo} alt="ID.me" height={30} />
                <Typography
                  component={"div"}
                  color={"slategrey"}
                  margin={0}
                  padding={0}
                  variant={"h3"}
                  fontWeight={600}
                >
                  +
                </Typography>
                <img src={DigitalRxLogo} alt="Digital_Rx" height={30} />
              </Box>
            </Grid>
            <Grid item>
              <Typography variant="h5" color={"error"}>
                {uuidError}
              </Typography>
            </Grid>
          </Grid>
        </IDMEPopupStyle>
      </>
    );
  }
  return (
    <>
      <IDMEPopupStyle>
        {IdmePreferenceData?.steps === "one" ? (
          <SelectAuthentication URL={URL} userUuidData={userUuidData} />
        ) : IdmePreferenceData?.steps === "two" ? (
          <MFASetupPreference
            userUuidData={userUuidData}
            setIsBack={setIsBack}
            isBack={isBack}
            setMfaSetupsData={setMfaSetupsData}
          />
        ) : IdmePreferenceData?.steps === "three" ? (
          <MFASetups
            isBack={isBack}
            setIsBack={setIsBack}
            userUuidData={userUuidData}
            mfaSetupsData={mfaSetupsData}
          />
        ) : IdmePreferenceData?.steps === "four" ? (
          <CompleteMFAEvent
            setIsBack={setIsBack}
            userUuidData={userUuidData}
            handleHidePopupClick={handleHidePopupClick}
            setVerifiedByIdmeUuid={setVerifiedByIdmeUuid}
          />
        ) : IdmePreferenceData?.steps === "five" ? (
          <CheckMFAEventStatus
            setIsBack={setIsBack}
            userUuidData={userUuidData}
            handleHidePopupClick={handleHidePopupClick}
            setVerifiedByIdmeUuid={setVerifiedByIdmeUuid}
          />
        ) : IdmePreferenceData?.steps === "success" ? (
          <Success />
        ) : IdmePreferenceData?.steps === "fail" ? (
          <Failure />
        ) : IdmePreferenceData?.steps === "invalidCode" ? (
          <InvalidCode />
        ) : IdmePreferenceData?.steps === "sessionTimeOut" ? (
          <SessionTimeOut />
        ) : (
          <ServiceUnavailable />
        )}
      </IDMEPopupStyle>
    </>
  );
}
